export default class CheckboxRadio {
  constructor() {
    // REQRUIRED fields
    this.requiredFields = document.querySelectorAll(
      'input[required=required]:not([type=hidden]), textarea[required=required], ul[aria-required=true], select[aria-required=true], div.optionset[aria-required=true], div.optionsetattribute[aria-required=true], select[required=required]'
    )

    // DISALBED fields
    this.disabledFields = document.querySelectorAll(
      'input:disabled:not([type=radio]):not([type=checkbox]):not([type=hidden]), textarea:disabled, select:disabled'
    )

    // SELECT fields
    this.selectFields = document.querySelectorAll('select')

    // CHECKBOX AND RADIO
    this.containerElements = document.querySelectorAll('.checkbox-container, .radio-container')

    this.init()
  }

  init() {
    if (this.requiredFields.length) {
      this.initRequiredFields()
    }

    if (this.disabledFields.length) {
      this.initDisabledFields()
    }

    if (this.selectFields.length) {
      this.initSelectFields()
    }

    if (this.containerElements.length) {
      this.initContainerElements()
    }
  }

  initRequiredFields() {
    if (!this.requiredFields.length) return

    for (let i = 0; i < this.requiredFields.length; i++) {
      const element = this.requiredFields[i]
      const field = element.closest('.field')
      field.classList.add('is--required')
    }
  }

  initDisabledFields() {
    if (!this.disabledFields.length) return

    for (let i = 0; i < this.disabledFields.length; i++) {
      const element = this.disabledFields[i]
      const field = element.closest('.field')
      field.classList.add('is--disabled')
    }
  }

  initSelectFields() {
    if (!this.selectFields.length) return

    for (let i = 0; i < this.selectFields.length; i++) {
      const element = this.selectFields[i]
      const field = element.closest('.field')

      if (field) {
        if (!element.value) {
          field.classList.add('is--empty')
        }

        element.addEventListener('change', () => {
          if (!element.value) {
            field.classList.add('is--empty')
          } else {
            field.classList.remove('is--empty')
          }
        })
      }
    }
  }

  initDisabledFields() {
    if (!this.disabledFields.length) return

    for (let i = 0; i < this.disabledFields.length; i++) {
      const element = this.disabledFields[i]
      const field = element.closest('.field')
      field.classList.add('is--disabled')
    }
  }

  initContainerElements() {
    if (!this.containerElements.length) return

    for (let i = 0; i < this.containerElements.length; i++) {
      const element = this.containerElements[i]
      const input = element.querySelector('input[type="radio"], input[type="checkbox"]')

      if (input && input.disabled) {
        this.onInputDisabled(element)
      }
      if (input && input.checked) {
        this.onInputChecked(element, input)
      }

      input.addEventListener('change', () => this.onInputChange(element, input))
    }
  }

  getRadioContainersByName(name) {
    const radioElements = document.querySelectorAll(`input[name="${name}"]`)
    if (radioElements.length) {
      const containers = []
      for (let i = 0; i < radioElements.length; i++) {
        const element = radioElements[i]
        const container = element.closest('.radio-container')
        containers.push(container)
      }
      return containers
    } else {
      return false
    }
  }

  onInputDisabled(container) {
    container.classList.add('is--disabled')
  }

  onInputChecked(container, input) {
    const type = input.type

    if (type === 'radio') {
      const name = input.name
      const radioContainers = this.getRadioContainersByName(name)

      if (radioContainers) {
        for (let i = 0; i < radioContainers.length; i++) {
          const element = radioContainers[i]
          element.classList.remove('is--checked')
        }
      }
    }

    container.classList.add('is--checked')
  }

  onInputChange(container, input) {
    if (input.checked) {
      this.onInputChecked(container, input)
    } else {
      container.classList.remove('is--checked')
    }
  }
}
